export const layoutResources = {
  'layout.header.accountDropdownTitle': 'Paramètres du compte',
  'layout.notifications.clearNotifications': 'Effacer les notifications reconnues',
  'layout.footer.copyright': `Droits d'auteur Shipium`,
};

export type LayoutResourceKey =
  | 'layout.header.accountDropdownTitle'
  | 'layout.notifications.clearNotifications'
  | 'layout.footer.copyright';
